import { MovimientosResponse, Movimientos } from 'ducks/movimientos'

export const parseContent = ({ groups }: MovimientosResponse): Movimientos => ({
  movimientos: groups.filter((group) => group !== null),
})

export const parseFeaturedContent = ({ groups }: MovimientosResponse): Movimientos => ({
  featuredMovimientos: groups.filter((group) => group !== null),
})
